"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.getEnd = exports.getStart = exports.init = void 0;
var ts_exhaustive_check_1 = require("ts-exhaustive-check");
var date_utils_1 = require("../date-utils");
function init(appointmentId, personId, userName, start, end, notes) {
    var startDate = (0, date_utils_1.dateToYYYY_MM_DD)(start);
    var startTime = appointmentId ? start.toTimeString().substr(0, 5) : "08:00";
    var endTime = appointmentId ? end.toTimeString().substr(0, 5) : "17:00";
    var endDate = (0, date_utils_1.dateToYYYY_MM_DD)(end);
    return {
        appointmentId: appointmentId,
        personId: personId,
        userName: userName,
        startDate: startDate,
        startTime: startTime,
        endTime: endTime,
        endDate: endDate,
        notes: notes,
    };
}
exports.init = init;
function getStart(state) {
    return (0, date_utils_1.YYYY_MM_ddT_HH_mm_toDate)("".concat(state.startDate, "T").concat(state.startTime));
}
exports.getStart = getStart;
function getEnd(state) {
    return (0, date_utils_1.YYYY_MM_ddT_HH_mm_toDate)("".concat(state.endDate, "T").concat(state.endTime));
}
exports.getEnd = getEnd;
function reducer(state, action) {
    switch (action.type) {
        case "SetNotes":
            return __assign(__assign({}, state), { notes: action.payload });
        case "SetStartTime":
            return __assign(__assign({}, state), { startTime: action.payload });
        case "SetEndTime":
            return __assign(__assign({}, state), { endTime: action.payload });
        case "SetEndDate":
            return __assign(__assign({}, state), { endDate: action.payload });
        default:
            return (0, ts_exhaustive_check_1.exhaustiveCheck)(action, true);
    }
}
exports.reducer = reducer;
//# sourceMappingURL=appointment-editor-state.js.map